import script from "./dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./dashboard.scss?vue&type=custom&index=0&blockType=link&issuerPath=D%3A%5Cvsts-agent%5C_work%5C53%5Cs%5Csrc%5Cviews%5Cdashboard%5Cdashboard.vue"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__